import { render, staticRenderFns } from "./RamoExecucao.vue?vue&type=template&id=4927c378"
import script from "./RamoExecucao.vue?vue&type=script&lang=js"
export * from "./RamoExecucao.vue?vue&type=script&lang=js"
import style0 from "./RamoExecucao.vue?vue&type=style&index=0&id=4927c378&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports